<mat-card>
    <mat-card-header>
        <mat-card-title>Required Observations</mat-card-title>
        <mat-card-subtitle class="subtitle-text-color-2">
            @if(forViewingOnly){
            Viewing only.
            }@else if(forSelection && !forViewingOnly){
            Select observations to add to the report.

            } @else {
            Enter results (saved as PRELIMINARY), then Confirm to finalize.
            }
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        @if(!forViewingOnly && forSelection){
        <div style="color: var(--mat-sys-primary); background-color: var(--mat-sys-surface);
        font-size: 14px;
                padding: 10px; border: 1px solid var(--mat-sys-primary); border-radius: 6px;  margin: 8px 0px 16px;
                ">
            <em>
                If you need to do anything more than select observations, please close this dialog and use the
                'add results' button on the service requests details view
            </em>
        </div>
        }
        <div class="g-just-flex gap-8 toolbar" style="justify-content: flex-end; flex-wrap: wrap;">
            @if(!forViewingOnly){
            <button mat-stroked-button color="primary" (click)="onAddObservationClick()"
                [disabled]="loading || editingLockedByServiceRequestCompletion"
                [class.pseudo-disabled]="!hasServiceRequest || editingLockedByServiceRequestCompletion"
                [attr.aria-disabled]="!hasServiceRequest || editingLockedByServiceRequestCompletion">
                <mat-icon>add</mat-icon>
                Add Observation
            </button>
            <button mat-stroked-button color="primary" (click)="confirmAll()"
                [disabled]="loading || rows.length === 0 || editingLockedByServiceRequestCompletion"
                [class.pseudo-disabled]="!hasServiceRequest || editingLockedByServiceRequestCompletion"
                [attr.aria-disabled]="!hasServiceRequest || editingLockedByServiceRequestCompletion">
                <mat-icon>done_all</mat-icon>
                Confirm All
            </button>
            <button mat-stroked-button color="warn" (click)="cancelAll()"
                [disabled]="loading || rows.length === 0 || editingLockedByServiceRequestCompletion">
                <mat-icon>cancel</mat-icon>
                Cancel All
            </button>
            }
            <button mat-icon-button (click)="refresh()" [disabled]="loading" title="Refresh">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>

        @if(loading){
        <div class="subtitle-text-color-2" style="padding: 12px 0;">Loading…</div>
        }

        @if(!loading && rows.length === 0){
        <div class="subtitle-text-color-2" style="padding: 12px 0;">No configured required observations found.</div>
        }

        @if(rows.length > 0){
        <div class="table-wrap">
            <table class="simple-table">
                <thead>
                    <tr>
                        @if(forSelection && !forViewingOnly){
                        <th style="max-width: 48px;">
                            <mat-checkbox [checked]="isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                (change)="setAllSelected($event.checked)" [aria-label]="checkboxLabel()">
                            </mat-checkbox>
                        </th>
                        }
                        <th style="width: 12%;">Updated</th>
                        <th style="width: 42%;">Test</th>
                        <th style="width: 12%;">Status</th>
                        <th style="width: 22%;">Result</th>
                        <th style="width: 12%;">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for(row of rows; track row.key){
                    <tr>
                        @if(forSelection && !forViewingOnly){
                        <td>
                            <mat-checkbox (click)="$event.stopPropagation()" [checked]="selection.isSelected(row)"
                                (change)="setSelected(row, $event.checked)" [aria-label]="checkboxLabel(row)"
                                [disabled]="forViewingOnly ||row?.observation?.status !== 'final'">
                            </mat-checkbox>
                        </td>
                        }
                        <td>
                            @if(row?.observation?.meta?.lastUpdated){
                            <span class="restrict-length">{{ row.observation.meta.lastUpdated | date:'shortDate'
                                }}</span>
                            <br>
                            <span class="restrict-length subtitle-text-color-2 small-subtitle">{{
                                row.observation.meta.lastUpdated | date:'shortTime' }}</span>
                            } @else {
                            <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                        <td>{{ formatCodeDisplay(row.requiredCodeableConcept) }}</td>
                        <td> @if( row.observation?.status){
                            <div [appChips]="row.observation.status" [fontSize]="'14px'"></div>
                            } @else {
                            <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                        <!-- {{row | json}} -->
                        <td><app-observation-value-display [observation]="row.observation"></app-observation-value-display></td>
                        <td>
                            <div class="g-just-flex gap-8" style="justify-content: flex-start; flex-wrap: wrap;">
                                <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Actions"
                                    [disabled]="forViewingOnly || editingLockedByServiceRequestCompletion || (!serviceRequest?.id && !row.observation)">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                                <mat-menu #rowMenu="matMenu">
                                    @if(forViewingOnly){
                                    <button mat-menu-item disabled>
                                        <mat-icon>visibility</mat-icon>
                                        <span>Viewing only</span>
                                    </button>
                                    } @else {
                                    <button mat-menu-item (click)="openResultDialog(row)"
                                        [disabled]="editingLockedByServiceRequestCompletion || (!serviceRequest?.id && !row.observation)"
                                        [class.pseudo-disabled]="!hasServiceRequest || editingLockedByServiceRequestCompletion"
                                        [attr.aria-disabled]="!hasServiceRequest">
                                        <mat-icon>edit</mat-icon>
                                        <span>Result</span>
                                    </button>
                                    @if (canManageManualReferenceRanges$ | async) {
                                        <button mat-menu-item (click)="openReferenceRangeDialog(row)"
                                            [disabled]="editingLockedByServiceRequestCompletion || !row.observation?.id">
                                            <mat-icon>analytics</mat-icon>
                                            <span>Manage Reference Range</span>
                                        </button>
                                    }
                                    <button mat-menu-item (click)="confirm(row)"
                                        [disabled]="editingLockedByServiceRequestCompletion || (!serviceRequest?.id && !row.observation?.id)">
                                        <mat-icon>check_circle</mat-icon>
                                        <span>Confirm</span>
                                    </button>
                                    <button mat-menu-item (click)="cancel(row)"
                                        [disabled]="editingLockedByServiceRequestCompletion || (!serviceRequest?.id && !row.observation?.id)">
                                        <mat-icon>block</mat-icon>
                                        <span>Cancel</span>
                                    </button>
                                    }
                                </mat-menu>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        }
    </mat-card-content>
    <mat-card-actions align="end" class="my-15">
        <button mat-stroked-button (click)="close()" [disabled]="loading">
            <mat-icon>check_circle</mat-icon>
            Submit
        </button>
    </mat-card-actions>
</mat-card>